import { Component, Input, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { GenericObjectDefinition } from '../../models/generic-object-definition.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { TableData } from '../../models/table-data.model';
import { TableColumn } from '../../models/table-column.model';
import { TableCellType } from '../../models/table-cell-type.enum';
import { TableRow } from '../../models/table-row.model';
import { TableSortColumn } from '../../models/table-sort-column.model';

@Component({
    selector: 'admin-object-list',
    templateUrl: './admin-object-list.component.html',
    styleUrls: ['./admin-object-list.component.scss']
})
export class AdminObjectListComponent extends ComponentView {

    app = inject(MainAppService);

    neededParams: ObjectOfSimpleDataTypes = { 
        scope: "string",
        id: "string"
     };
    
    @Input()
    scope: string;
    @Input()
    id: string;

    def: GenericObjectDefinition;
    data: any[] = [];
    table: TableData;
    
    
    async initParams(): Promise<boolean> {
        this.def = this.app.mainConfig.genericObjectDefinitions.find(item => item.scope == this.scope && item.id == this.id);
        this.data = await this.app.loadDataHandler(async () => RestEndpoint.main().run(this.def.apiEndpoint).listObjects(), this);

        this.table = new TableData([
            new TableColumn("label", "Name", TableCellType.text, { flex: 1 })
        ], this.data.map(o => new TableRow("", o, {
            label: o.label
        })), [new TableSortColumn("label")]);
        
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: this.def.title, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id] }
        ]);
        return true;
    }

    async rowSelect(row: TableRow): Promise<void> {
        await this.app.navigateTo(["/base2", "admin", "generic-edit", this.scope, this.id, row.raw.key]);
    }

    async deleteRow(row: [TableRow, number]): Promise<void> {
      /*  if ((await this.app.deleteDataHandler<string>(async () => RestEndpoint.main().query({id: row[0].raw.id}).delete().run(this.restUrl).getText()))[0]) {
           // this.onDelete.emit(row[0]);
        }*/
    }
}
